<template lang="pug">
.queue-info
  .queue-notice {{notice}}
  template(v-if="exp.queueCode")
    .queue-code
      .code-wrapper
        span.code {{exp.queueCode.queueCode}}
        span.amount(v-if="exp.queueCode.quotas.length > 0") /{{exp.queueCode.quotas.length}}位
      .avatars(v-if="exp.queueCode.quotas.length > 0")
        queue-avatar(v-for="quota in exp.queueCode.quotas" :check="quota.quota === 0" :avatar="quota.userAvatar")
  template(v-else-if="exp.access === 1")
    .queue-btn.fs-s(@click="onQueue") 排号
  template(v-else)
    //member-ticket-money(:grade="grade" :price="ticket? ticket.ticketMoney: ''" @clicked="onPurchase")
  
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import MemberTicketMoney from '@/components/wedgits/MemberTicketMoney'
import QueueAvatar from '@/components/home/QueueAvatar'
export default {
  name: 'QueueInfo',
  components: { QueueAvatar, MemberTicketMoney },
  props: {
    exhibitId: {},
  },
  data() {
    return {
      notice: '',
    }
  },
  computed: {
    ...mapState('app', ['user']),
    exp() {
      return this.user.checkin
        ? this.user.checkin.exhibitExps.filter((exp) => {
            return exp.exhibitId === this.exhibitId
          })[0]
        : {}
    },
    ticket() {
      return this.user.tickets
        ? this.user.tickets.filter((t) => {
            return (
              t.ticketType === 1 && t.exhibits[0].exhibitId === this.exhibitId
            )
          })[0]
        : {}
    },
    grade() {
      return this.user.grade
    },
  },
  watch: {
    exp: {
      deep: true,
      handler(exp) {
        this.handleExp(exp)
      },
    },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    ...mapActions('app', ['QueueRedeem', 'GetUser']),
    handleExp(exp) {
      console.log(777, exp)
      //if (!exp.queue) return
      if (exp.queueCode) {
        // let queue = exp.queue.queues.filter((q) => {
        //   return q.queueStatus === 1
        // })
        // queue.map((q, i) => {
        //   if (q.queueCode === exp.queueCode) {
        //     if (i > 0) {
        //       this.notice = `前面还有${i}位, 预计等待${i * 5}分钟`
        //     } else {
        //       this.notice = '已到号'
        //     }
        //   }
        // })
        if (exp.queueCode.order > 0) {
          this.notice = `前面还有${exp.queueCode.order}位, 预计等待${exp
            .queueCode.order * 5}分钟`
        } else {
          this.notice = '已到号'
        }
      } else {
        // let queue = exp.queue.queues.filter((q) => {
        //   return q.queueStatus === 1
        // })
        if (exp.queueAhead > 0) {
          this.notice = `前面还有${exp.queueAhead}位, 预计等待${exp.queueAhead *
            5}分钟`
        } else {
          this.notice = '当前无人排队'
        }
      }
    },
    onPurchase() {
      this.$router.replace(`/home/ticketOrder/${this.ticket.ticketId}`)
      this.setRouterBack('/')
    },
    onQueue() {
      this.setPending(true)
      this.QueueRedeem({
        userId: this.user.id,
        exhibitId: this.exhibitId,
      }).then((res) => {
        console.log('queue redeem', res)
        this.GetUser(this.user.id).then((res) => {
          this.setPending(false)
        })
      })
    },
    parseExp(exp) {
      if (exp.queueCode) {
        let queue = exp.queue.queues.filter((q) => {
          return q.queueStatus === 1
        })
        queue.map((q, i) => {
          if (q.queueCode === exp.queueCode) {
            exp.queueAhead = i
            exp.order = i
          }
        })
      } else {
        let queue = exp.queue.queues.filter((q) => {
          return q.queueStatus === 1
        })
        exp.queueAhead = queue.length
      }
      return exp
    },
  },
  mounted() {
    console.log(999, this.exp)
    this.handleExp(this.exp)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.queue-info
  .queue-notice
    color: white
    margin-top: pxToRem(10)
    font-size: pxToRem(24)
    text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
  .queue-code
    color: white
    position: relative
    line-height: pxToRem(60)
    display: flex
    flex-direction: row
    align-items: baseline
    .code-wrapper
      margin-right: pxToRem(15)
      .code
        font-size: pxToRem(54)
      .amount
        font-size: pxToRem(30)
    .avatars
      display: flex
      flex-direction: row
      .queue-avatar
  .queue-btn
    color: $cl-blue
    height: pxToRem(60)
    border-radius: pxToRem(30)
    line-height: pxToRem(60)
    background: white
    padding: 0 pxToRem(24)
    text-align: center
    width: pxToRem(150)
    margin-top: pxToRem(10)
</style>
